import { FC, memo } from 'react'

import { ArrowRightIcon, Button, Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Breadcrumb } from 'components/breadcrumb'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { HeroProps } from './hero.model'
import * as S from './styles'

const Hero: FC<HeroProps> = memo(({ onClick }) => {
  const { isMobile } = useWindowSize()

  const BreadcrumbLinks = [
    { label: 'Empréstimo Online' }
  ]

  return (
    <S.Hero>
      <Grid col={{ phone: 1, tablet: 2, desktop: 12 }}>
        {!isMobile && 
          <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
            <S.ImageWrapper>
              <NextImage
                src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/online-loan/man-with-notebook.png?updated=230601`}
                alt="Homem usando notebook"
                width="538"
                height="519"
                quality={90}
                priority
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "auto"
                }} />
            </S.ImageWrapper>
          </Col>
        }
        <Col col={{ desktop: 5 }}>
          <S.Infos>
            <Breadcrumb items={BreadcrumbLinks} />
            <Text as="h1" size="heading2" weight="medium">
              <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
                Empréstimo Online {' '}
              </Text>
              com a menor taxa
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Crédito online urgente com simulação rápida e segura. Aproveite as vantagens:
            </Text>
            {isMobile && 
              <Button
                size="lg"
                onClick={onClick}
              >
                Simular agora
              </Button>
            }
            <S.LoanInfos>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Até 240 meses para pagar;
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Simulação 100% online;
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  A partir de R$ 50 mil;
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Use seu imóvel como garantia.
                </Text>
              </S.LoanInfosItem>
            </S.LoanInfos>
            {!isMobile && 
              <Button size="lg" onClick={onClick}>
                Simular agora <ArrowRightIcon />
              </Button>
            }
          </S.Infos>
        </Col>
      </Grid>
    </S.Hero>
  );
})

Hero.displayName = 'Hero'

export default Hero
